export default __webpack_public_path__ + "static/media/natasha.c078a450.svg";